/** @type {() => typeof import("./reducer.js").initState} */
const selectRoot = (state) => state.helpdesk;

export const selectTicket = (state) => selectRoot(state).ticket;
export const selectTicketList = (state) => selectRoot(state).ticketList;
export const selectTicketCategory = (state) => selectRoot(state).ticketCategory;
export const selectTicketCategoryList = (state) => selectRoot(state).ticketCategoryList;
export const selectTicketStats = (state) => selectRoot(state).ticketStats;
